import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery('Blog', `_id title contentHtml updatedAt cover`)
